interface FuturaLogoProps {
  className?: string
  size?: 'sm' | 'md'
}

export function FuturaLogoIcon({ size = 'sm' }: { size?: 'sm' | 'md' }) {
  const dim = size === 'sm' ? 24 : 40

  return (
    <svg
      width={dim}
      height={dim}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="shrink-0"
      aria-label="Futura Research Logo"
    >
      <path
        d="M16 2L28 9V23L16 30L4 23V9L16 2Z"
        fill="#36a7a7"
        style={{ opacity: 0.14 }}
      />
      <rect x="8" y="6" width="4" height="20" fill="#36a7a7" />
      <path d="M12 6H24V10H12V6Z" fill="currentColor" />
      <path d="M12 14H20V18H12V14Z" fill="currentColor" />
      <circle cx="21" cy="23" r="2" fill="#36a7a7" />
    </svg>
  )
}

export function FuturaLogo({ className = '', size = 'sm' }: FuturaLogoProps) {
  const textSizes = size === 'sm'
    ? { name: 'text-[14px]', sub: 'text-[7px]' }
    : { name: 'text-[20px]', sub: 'text-[11px]' }

  return (
    <a
      href="https://www.futura-research.com/"
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-2 transition-opacity hover:opacity-80 ${className}`}
    >
      <FuturaLogoIcon size={size} />
      <div className="flex flex-col leading-none">
        <span className={`font-mono font-bold tracking-wider ${textSizes.name}`}>
          FUTURA
        </span>
        <span
          className={`font-mono text-muted-foreground ${textSizes.sub}`}
          style={{ letterSpacing: '0.34em' }}
        >
          RESEARCH
        </span>
      </div>
    </a>
  )
}
